import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_VIDA_URL;
import usersUtils from '../utils/user';

export default {
  async getCreditCardRefunds(purchaseId) {
    try {
      const response = await axios.get(
        `${apiUrl}/credit-card/${purchaseId}/refunds`,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async createCreditCardRefund(purchaseId, payload) {
    try {
      const response = await axios.post(
        `${apiUrl}/credit-card/${purchaseId}/refunds`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
